import { c as _c } from "react/compiler-runtime";
import type { ProcessedContent } from "./media-utils";
import ContentSegmentComponent from "./ContentSegmentComponent";
import MediaThumbnail from "./MediaThumbnail";
interface ContentDisplayProps {
  readonly content: ProcessedContent;
  readonly onClick?: () => void;
  readonly className?: string | undefined;
  readonly textClassName?: string | undefined;
  readonly shouldClamp?: boolean;
  readonly linkify?: boolean;
  readonly linkClassName?: string | undefined;
}

/**
 * Component to display processed content with text segments and media
 */
export default function ContentDisplay(t0) {
  const $ = _c(23);
  const {
    content,
    onClick,
    className,
    textClassName,
    shouldClamp: t1,
    linkify: t2,
    linkClassName
  } = t0;
  const shouldClamp = t1 === undefined ? true : t1;
  const linkify = t2 === undefined ? true : t2;
  const clampClass = shouldClamp ? "tw-line-clamp-1" : "";
  const t3 = onClick ? "tw-cursor-pointer hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out" : "";
  const t4 = className ?? "";
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = ["tw-text-iron-400 tw-font-normal tw-text-sm tw-flex tw-items-center tw-gap-1.5", t3, t4].filter(Boolean);
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const containerClasses = t5.join(" ");
  const t6 = textClassName ?? "";
  let t7;
  if ($[3] !== clampClass || $[4] !== t6) {
    t7 = [clampClass, t6].filter(Boolean);
    $[3] = clampClass;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const textClasses = t7.join(" ");
  let t8;
  if ($[6] !== content.segments || $[7] !== linkClassName || $[8] !== linkify) {
    let t9;
    if ($[10] !== linkClassName || $[11] !== linkify) {
      t9 = (segment, i) => <ContentSegmentComponent key={`segment-${i}`} segment={segment} index={i} linkify={linkify} linkClassName={linkClassName} />;
      $[10] = linkClassName;
      $[11] = linkify;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    t8 = content.segments.map(t9);
    $[6] = content.segments;
    $[7] = linkClassName;
    $[8] = linkify;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[13] !== t8 || $[14] !== textClasses) {
    t9 = <span className={textClasses}>{t8}</span>;
    $[13] = t8;
    $[14] = textClasses;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== content.apiMedia) {
    t10 = content.apiMedia.map(_temp);
    $[16] = content.apiMedia;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== containerClasses || $[19] !== onClick || $[20] !== t10 || $[21] !== t9) {
    t11 = <span className={containerClasses} onClick={onClick}>{t9}{t10}</span>;
    $[18] = containerClasses;
    $[19] = onClick;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}
function _temp(media, i_0) {
  return <MediaThumbnail key={`api-media-${i_0}`} media={media} />;
}